<template>

    <form @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)" ref="form" autocomplete="off">

        <input type="hidden" name="stay-on-page" v-model="stayOnPage">

        <div class="row">

            <div class="col-md-6">

                <div class="form-group">
                    <label for="login">Login</label>
                    <input type="text" class="form-control" id="login" v-model="form.login" autocomplete="off" data-lpignore="true">
                    <span class="error mt-2 text-danger" v-if="form.errors.has('login')" v-text="form.errors.get('login')"></span>
                </div>

                <div class="form-group">
                    <label for="email">Email</label>
                    <input type="text" class="form-control" id="email" v-model="form.email" autocomplete="off" data-lpignore="true">
                    <span class="error mt-2 text-danger" v-if="form.errors.has('email')" v-text="form.errors.get('email')"></span>
                </div>

                <div class="form-group">
                    <label for="user_groups_ids">Grupy użytkowników</label>
                    <select2 id="user_groups_ids" ref="userGroupsIdsSelect" :options="userGroupsOptions" v-model="form.user_groups_ids" multiple></select2>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="hide_token_groups" v-model="hideTokenUserGroups">
                        <label class="custom-control-label" for="hide_token_groups" style="font-size: 0.875rem; line-height: 1.6;">Ukryj grupy tokenowe</label>
                    </div>
                    <span class="error mt-2 text-danger" v-if="form.errors.has('user_groups_ids')" v-text="form.errors.get('user_groups_ids')"></span>
                </div>

                <div class="mb-4">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="is_superuser" v-model="form.is_superuser">
                        <label class="custom-control-label" for="is_superuser" style="font-size: 0.875rem; line-height: 1.6;">Super administrator</label>
                    </div>
                    <span class="error mt-2 text-danger" v-if="form.errors.has('is_superuser')" v-text="form.errors.get('is_superuser')"></span>
                </div>

                <div class="form-group">
                    <label for="languages">Języki</label>
                    <select2 id="languages" :options="languagesOptions" v-model="form.languages" multiple></select2>
                    <span class="error mt-2 text-danger" v-if="form.errors.has('languages')" v-text="form.errors.get('languages')"></span>
                    <small>{{ t.__('Języki dostępne do tłumaczenia dla użytkowników nieadministracyjnych (np. dla materiałów marketingowych).') }}</small>
                </div>

            </div>

            <div class="col-md-6">

                <div class="form-group">
                    <label for="password">Hasło</label>
                    <input type="password" class="form-control" id="password" v-model="form.password" autocomplete="off" data-lpignore="true">
                    <span class="error mt-2 text-danger" v-if="form.errors.has('password')" v-text="form.errors.get('password')"></span>
                </div>

                <div class="form-group">
                    <label for="password_confirmation">Potwierdź hasło</label>
                    <input type="password" class="form-control" id="password_confirmation" v-model="form.password_confirmation" autocomplete="off" data-lpignore="true">
                    <span class="error mt-2 text-danger" v-if="form.errors.has('password_confirmation')" v-text="form.errors.get('password_confirmation')"></span>
                </div>

                <hr>

                <div class="form-group">
                    <label for="api_token">{{ t.__('Token API') }}</label>
                    <input type="text" class="form-control" id="api_token" :value="token" readonly>
                    <small>{{ t.__('Ze względów bezpieczeństwa token jest widoczny tylko po wygenerowaniu') }}</small>
                    <br>
                    <a href="javascript:void(0);" class="btn btn-primary btn-sm mt-2" @click="generateApiToken()">{{ t.__('Generuj nowy') }}</a>
                </div>

                <p>{{ t.__('W celu poprawnej autoryzacji podczas połączenia z API, należy umieścić wygenerowany powyżej token w nagłówku Authorization') }}</p>
                <pre>Authorization: Bearer [{{ t.__('twój token') }}]</pre>
                <p>{{ t.__('Dodatkowo należy dołączyć poniższy nagłówek') }}</p>
                <pre>Accept: application/json</pre>

                <br>

                <h5>{{ t.__('Dostępne zasoby') }}</h5>

                <br>

                <p>1. {{ t.__('Pobierz listę maszyn') }}</p>
                <pre class="mb-0">GET https://ifpanel.net/api/machine/machines/list</pre>

                <br>

                <p>2. {{ t.__('Pobierz szczegóły maszyny') }}</p>
                <pre class="mb-0">GET https://ifpanel.net/api/machine/machines/details?[id=... serial_number=... hostname=... ip=... mac=... sim_code=...]</pre>
                <small>{{ t.__('Wymagany przynajmniej jeden z parametrów') }}</small>

                <br>

                <p class="mt-4">3. {{ t.__('Aktualizuj właściwości maszyny') }}</p>
                <pre class="mb-0">PUT https://ifpanel.net/api/machine/machines/update-details?[id=... serial_number=... hostname=... ip=... mac=... sim_code=...]</pre>
                <small>{{ t.__('Wymagany przynajmniej jeden z parametrów') }}</small>
                <p class="mt-3 mb-0">{{ t.__('Dane zapytania') }}:</p>
                <ul>
                    <li><b>name</b> <i>string</i> | {{ t.__('wymagane, dopuszczalne puste') }}</li>
                    <li><b>notes</b> <i>string</i> | {{ t.__('wymagane, dopuszczalne puste') }}</li>
                    <li><b>repo</b> <i>string/select</i> ({{ t.__('wybór jednego z dostępnych repozytoriów dla wybranej maszyny, np. [dev, test, prod]') }}) | {{ t.__('wymagane, nie puste') }}</li>
                    <li><b>autoupdate</b> <i>boolean</i> | {{ t.__('wymagane, nie puste') }}</li>
                    <li><b>language</b> <i>string/select</i> ({{ t.__('dwuznakowy kod języka, pisany małymi literami, np. [pl, en, nl ... ]') }}) | {{ t.__('wymagane, nie puste') }}</li>
                    <li><b>timezone</b> <i>string/select</i> ({{ t.__('strefa czasowa w formacie Region/Miasto, np. [Europe/Warsaw, Europe/London, Europe/Amsterdam ... ]') }}) | {{ t.__('wymagane, nie puste') }}</li>
                </ul>

            </div>

        </div>

    </form>

</template>

<script>

    export default {

        name: 'UserForm',

        props: [
            'formType',
            'user',
            'userGroups',
            'languages'
        ],

        data() {
            let form;
            if (this.formType === 'edit') {
                form = new Vue.prototype.Form({
                    login: this.user.login,
                    email: this.user.email,
                    password: '',
                    password_confirmation: '',
                    user_groups_ids: this.user.user_groups.map(userGroup => userGroup.id),
                    is_superuser: this.user.is_superuser,
                    languages: this.user.languages !== null ? this.user.languages : []
                });
            } else {
                form = new Vue.prototype.Form({
                    login: '',
                    email: '',
                    password: '',
                    password_confirmation: '',
                    user_groups_ids: [],
                    is_superuser: false,
                    languages: ['en']
                });
            }
            return {
                eventHub: window.eventHub,
                form: form,
                token: null,
                hideTokenUserGroups: true,
                stayOnPage: false
            }
        },

        computed: {
            userGroupsOptions() {
                let userGroupsOptions = [];
                this.userGroups.forEach(userGroup => {
                    if (this.hideTokenUserGroups === false || (this.hideTokenUserGroups === true && userGroup.is_related_with_token === 0)) {
                        userGroupsOptions.push({
                            text: userGroup.name,
                            id: userGroup.id
                        });
                    }
                });
                console.log(userGroupsOptions);
                return userGroupsOptions;
            },
            languagesOptions() {
                let languagesOptions = [];
                this.languages.forEach(language => {
                    languagesOptions.push({
                        text: language.name,
                        id: language.code
                    });
                });
                return languagesOptions;
            },

        },

        beforeMount() {

            if (this.user.api_token !== null) {
                this.token = '*'.repeat(80);
            } else {
                this.token = t.__('Nie został jeszcze wygenerowany');
            }

        },

        created () {
            this.eventHub.$on('submit-form', (stay) => {
                this.stayOnPage = stay;
                this.onSubmit();
            })
        },

        beforeDestroy () {
            this.eventHub.$off('submit-form')
        },

        methods: {
            onSubmit() {
                if (this.formType === 'edit') {
                    this.form.put(route('user::users.update', {id: this.user.id}))
                        .then((response) => {
                            if (this.stayOnPage) {
                                this.eventHub.$emit('processing-finish');
                                this.eventHub.$emit('toast-notification', response.message, 'success');
                            } else {
                                window.location.href = route('user::users.index') + '?status-message=success:' + response.message;
                            }
                        })
                        .catch(this.onResponseError);
                } else {
                    this.form.post(route('user::users.store'))
                        .then((response) => {
                            if (this.stayOnPage) {
                                window.location.href = route('user::users.edit', {id: response.data.user.id}) + '?status-message=success:' + response.message;
                            } else {
                                window.location.href = route('user::users.index') + '?status-message=success:' + response.message;
                            }
                        })
                        .catch(this.onResponseError);
                }
            },

            onResponseError(response) {
                this.eventHub.$emit('processing-finish');
                this.eventHub.$emit('toast-notification', 'Coś poszło nie tak. Sprawdź poprawność danych.', 'error');
            },

            generateApiToken() {
                this.eventHub.$emit('processing-start');
                axios.get(route('user::users.generate-api-token', {id: this.user.id}))
                    .then((response) => {
                        this.token = response.data.data.token;
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', response.data.message, 'success');
                    })
                    .catch((response) => {
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak. Sprawdź poprawność danych.'), 'error');
                    });
            }
        }
    }

</script>

<style scoped>

</style>
